"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardInlinePreviewsOption')(function discardInlinePreviewsOption(state) {
    var optionState = state.optionState;
    optionState.isEnabled = null;
}));
//# sourceMappingURL=discardInlinePreviewsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inline-previews-option/lib/actions/discardInlinePreviewsOption.js
// module id = 5098
// module chunks = 2